
import {
  IconBuilding,
  IconUsersGroup,
  IconShield,
  IconKey,
  IconWorld,
  IconLanguage,
  IconCurrencyEuro,
  IconUser,
  IconLayoutGrid
} from '@tabler/icons-react';
import type { NavItemType } from 'types';

const icons = {
  IconBuilding,
  IconUsersGroup,
  IconShield,
  IconKey,
  IconWorld,
  IconLanguage,
  IconCurrencyEuro,
  IconUser,
  IconLayoutGrid
};

const admin: NavItemType = {
  id: 'admin',
  title: 'Admin',
  type: 'group',
  children: [
    {
      id: 'admin-hotels',
      title: 'Hotelek',
      type: 'collapse',
      icon: icons.IconBuilding,
      children: [
        {
          id: 'admin-hotels-list',
          title: 'Hotelek',
          type: 'item',
          url: '/admin/hotels',
          breadcrumbs: false
        },
        {
          id: 'admin-hotel-hotel-groups',
          title: 'Hotel–csoport kapcsolatok',
          type: 'item',
          url: '/admin/hotel-hotel-groups',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'admin-hotel-groups',
      title: 'Hotel csoportok',
      type: 'item',
      url: '/admin/hotel-groups',
      icon: icons.IconUsersGroup,
      breadcrumbs: false
    },
    {
      id: 'admin-permission-templates',
      title: 'Jogosultsági sablonok',
      type: 'item',
      url: '/admin/permission-templates',
      icon: icons.IconShield,
      breadcrumbs: false
    },
    {
      id: 'admin-permissions',
      title: 'Jogosultságok',
      type: 'item',
      url: '/admin/permissions',
      icon: icons.IconKey,
      breadcrumbs: false
    },
    {
      id: 'admin-users',
      title: 'Felhasználók',
      type: 'collapse',
      icon: icons.IconUser,
      children: [
        {
          id: 'admin-user-permissions',
          title: 'Felhasználók',
          type: 'item',
          url: '/admin/user-permissions',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'admin-countries',
      title: 'Országok',
      type: 'item',
      url: '/admin/countries',
      icon: icons.IconWorld,
      breadcrumbs: false
    },
    {
      id: 'admin-languages',
      title: 'Nyelvek',
      type: 'item',
      url: '/admin/languages',
      icon: icons.IconLanguage,
      breadcrumbs: false
    },
    {
      id: 'admin-currencies',
      title: 'Pénznemek',
      type: 'item',
      url: '/admin/currencies',
      icon: icons.IconCurrencyEuro,
      breadcrumbs: false
    },
    {
      id: 'admin-layout-types',
      title: 'Elrendezés típusok',
      type: 'item',
      url: '/admin/layout-types',
      icon: icons.IconLayoutGrid,
      breadcrumbs: false
    }
  ]
};

export default admin;
